import { Directive, forwardRef, HostBinding, Input } from '@angular/core';

import { KH_A11Y_TARGET } from '../constants/a11y-target.token';
import { A11yBooleanInput, A11yRole } from '../interfaces/a11y.interfaces';
import { toBoolean } from '../utils/a11y.util';

import { A11yLabelDirective } from './a11y-label.directive';

@Directive({
  selector: '[khA11yImage]',
  providers: [{ provide: KH_A11Y_TARGET, useExisting: forwardRef(() => A11yImageDirective) }]
})
export class A11yImageDirective extends A11yLabelDirective implements A11yRole {
  @Input() public decorative: A11yBooleanInput = false;

  @HostBinding('attr.role')
  public get role(): 'img' | null {
    return this.decorativeState ? null : 'img';
  }

  @HostBinding('attr.aria-hidden')
  public get ariaHidden(): 'true' | null {
    return this.decorativeState ? 'true' : null;
  }

  protected override get ariaLabelValue(): string | null {
    return this.decorativeState ? null : this.a11yLabel;
  }

  protected override get ariaLabelledByValue(): string | null {
    return this.decorativeState ? null : this.a11yLabelledBy;
  }

  protected override get ariaDescribedByValue(): string | null {
    return this.decorativeState ? null : this.a11yDescribedBy;
  }

  private get decorativeState(): boolean {
    return toBoolean(this.decorative, true);
  }
}
